var map = {
	"./nav01_ok.png": "./src/assets/newicons/nav01_ok.png",
	"./nav02_ok.png": "./src/assets/newicons/nav02_ok.png",
	"./nav03_ok.png": "./src/assets/newicons/nav03_ok.png",
	"./nav04_ok.png": "./src/assets/newicons/nav04_ok.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/newicons sync recursive ^\\.\\/.*_ok\\.png$";